import Checkbox from '@/components/atoms/legacy/Checkbox';
import { ScComponent } from '@/types/interfaces';
import { CheckIcon } from '@heroicons/react/24/outline';
import React from 'react';
import clsx from 'clsx';

export enum DropdownMenuItemVariants {
  NoSelect = 'no-select',
  MultiSelect = 'multi-select',
  SingleSelect = 'single-select',
}

export interface DropdownMenuItemProps extends ScComponent {
  variant?: DropdownMenuItemVariants;
  text: string;
  selected: boolean;
  showCount?: boolean;
  onChange: () => void;
  iconNode?: React.ReactNode;
}

const DropdownMenuItem: React.FC<DropdownMenuItemProps> = ({
  className = '',
  variant = DropdownMenuItemVariants.SingleSelect,
  text,
  selected,
  onChange = () => {},
  iconNode,
}) => {
  return (
    <label
      className={clsx(
        'flex w-full cursor-pointer items-center rounded-small px-l py-xl text-body1Light text-neutral-900 hover:bg-neutral-200 md:px-[14px] md:py-[10px]',
        {
          'bg-blue-light text-brandMidnight': selected,
        },
        className
      )}
      onMouseDown={() => {
        if (variant === DropdownMenuItemVariants.NoSelect) onChange();
      }}
    >
      {variant !== DropdownMenuItemVariants.NoSelect && (
        <Checkbox
          className={`${
            variant === DropdownMenuItemVariants.MultiSelect ? '' : 'hidden'
          } mr-[8px]`}
          checked={selected}
          onChange={onChange}
        />
      )}
      {iconNode}
      <span className="text-body1Regular md:text-body1Light">{text}</span>
      <section className="ml-auto flex items-center justify-between space-x-[10px]">
        {variant === DropdownMenuItemVariants.SingleSelect && selected && (
          <CheckIcon width={20} height={20} stroke="#516670" />
        )}
      </section>
    </label>
  );
};

export default DropdownMenuItem;
